export const AddressLabelFlg = [
  { label: '発行しない', value: '0' },
  { label: '発行する', value: '1' },
];
